import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthComponent } from './pages/auth/auth.component';
import { ConfigComponent } from './pages/config/config.component';
import { ForgotPasswordComponent } from './pages/forgot-password/forgot-password.component';
import { RecoverPasswordComponent } from './pages/recover-password/recover-password.component';
import { ConnectedDevicesComponent } from './pages/connected-devices/connected-devices.component';
import { MultiFactorAuthenticationComponent } from './pages/auth/multi-factor-authentication/multi-factor-authentication.component';


const routes: Routes = [
  { path: '', component: AuthComponent, pathMatch: 'full' },
  { path: 'gpa', component: AuthComponent },
  { path: 'auth', component: AuthComponent },
  { path: 'config', component: ConfigComponent },
  { path: 'forgot-password', component: ForgotPasswordComponent },
  { path: 'recover-password', component: RecoverPasswordComponent },
  { path: 'connected-devices', component: ConnectedDevicesComponent },
  { path: 'multi-factor-authentication', component: MultiFactorAuthenticationComponent },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AuthRoutingModule { }
